<template>
    <div>
        <el-upload
            ref="uploadRef"
            :multiple="multiple"
            :accept="accept"
            :auto-upload="true"
            :show-file-list="true"
            :headers="headers"
            :action="action"
            :http-request="upload2oss"
            :before-upload="beforeUpload"
            :on-change="onChange"
            :on-remove="onRemove"
            :on-success="onSuccess"
            :name="name"
            v-if="!readonly"
        >
            <el-button
                slot="trigger"
                :loading="loading"
                size="small"
                type="success"
                >Upload</el-button
            >
            <slot></slot>
        </el-upload>
    </div>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import axios from "axios";
export default {
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        // 限制上传的图片数量
        limit: {
            type: Number,
            default: 1,
        },
        // 接受的文件格式
        accept: {
            type: String,
            default: "image/*",
        },
        action: {
            type: String,
            default: cmofferApi.uploadToSite_url,
        },
        name: {
            type: String,
            default: "img",
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        clearFiles:{
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            headers: {
                token: localStorage.getItem("token"),
            },
            loading: false,
            imgList: [],
        };
    },
    methods: {
        onRemove(file, fileList){
            this.$emit("imagesChange", fileList);
        },
        onChange(file, fileList) {
            //如果第二次上传文件，将前一个文件删除, 这样就保持一个文件
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }
        },
        onExceed() {
            this.$message.error(`File cannot exceed ${this.limit}`);
        },
        onSuccess(res) {
            this.loading = false;
            // if (this.imgList.length >= this.limit) {
            //     this.$message.error(`File cannot exceed ${this.limit}`);
            // } else {
            if ((res.errcode || res.code) === 200) {
                // this.imgList.push(res.data.url);
                this.imgList = res.data.url;
                this.$emit("imagesChange", this.imgList);
            } else {
                this.$message.error(res.msg || res.errmsg);
            }
            // }
        },
        // 获取拓展名
        getSuffix(filename) {
            return filename.substring(filename.lastIndexOf("."));
        },
        // token
        async getOssToken() {
            return axios
                .get(`${cmofferApi.ossToken_url}?t=${new Date().getTime()}`)
                .then((res) => res.data);
        },
        // 上传 oss
        async upload2oss(fileObj) {
            const { file } = fileObj;
            this.loading = true;
            return this.getOssToken().then((tokenData) => {
                console.log("tokenData: ", tokenData);
                const { host, policy, accessid, signature, callback } =
                    tokenData;
                const key =
                    tokenData.filename +
                    this.getSuffix(file.name).toLowerCase();
                const photo = file; // 获取图片对象

                let param = new FormData();
                param.append("name", key);
                param.append("key", key);
                param.append("policy", policy);
                param.append("OSSAccessKeyId", accessid);
                param.append("success_action_status", 200); // 不要问为什么，照做
                param.append("callback", callback);
                param.append("signature", signature);
                param.append("file", photo, key); // 这个**切记**一定要放到最后去 append ，不然阿里云会一直报 key 的错误

                return axios
                    .post(host, param)
                    .then((res) => {
                        this.loading = false;
                        return res.data;
                    })
                    .catch(() => {
                        this.$message.error(
                            this.$i18n.locale == "zh"
                                ? "上传文件失败 "
                                : "Uploading files failed"
                        );
                    });
            });
        },
    },
    watch:{
        clearFiles:{
            handler(val){
                if(val){
                    this.$refs.uploadRef.clearFiles();
                    this.$emit("update:clearFiles", false);
                }
            }
        }
    }
};
</script>

<style>
</style>